import { render, staticRenderFns } from "./PortalPackageStep.vue?vue&type=template&id=72c129f0"
import script from "./PortalPackageStep.vue?vue&type=script&lang=js"
export * from "./PortalPackageStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports